// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.favButtonSmall {
    position: relative;
    z-index: 1;
    margin: 0px 0 0 0;
    background: none;
    border: none;
    cursor: pointer;
}

.favButtonSmall img {
    width: 24px;
    height: 24px;
    transition: transform 0.3s ease, filter 0.3s ease;
}

.favButtonSmall.active img {
    transform: scale(1.1);
    filter: brightness(1.2) contrast(1.1);
}

.favButtonBig {
    background: none;
    border: none;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Main/FavouritesButton/FavouritesButton.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iDAAiD;AACrD;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".favButtonSmall {\n    position: relative;\n    z-index: 1;\n    margin: 0px 0 0 0;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.favButtonSmall img {\n    width: 24px;\n    height: 24px;\n    transition: transform 0.3s ease, filter 0.3s ease;\n}\n\n.favButtonSmall.active img {\n    transform: scale(1.1);\n    filter: brightness(1.2) contrast(1.1);\n}\n\n.favButtonBig {\n    background: none;\n    border: none;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
